<template>
  <!-- Screenshot tile for the top-right action bar. Self-contained: it paints its own
       rounded background, so it sits directly on the canvas. -->
  <svg
    width="37"
    height="30"
    viewBox="0 0 37 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clip-path="url(#action-screenshotactionicon-clip0)">
    <rect width="37" height="30" rx="7" fill="#27292C"/>
    <path d="M28.0149 11.7824C28.0149 11.4177 27.8736 11.068 27.6223 10.8101C27.3708 10.5522 27.0298 10.4074 26.6742 10.4074H23.9928L21.9818 7.65723H16.6191L14.6081 10.4074H11.9267C11.5711 10.4074 11.2301 10.5522 10.9787 10.8101C10.7272 11.068 10.586 11.4177 10.586 11.7824V20.0328C10.586 20.3975 10.7272 20.7472 10.9787 21.0051C11.2301 21.263 11.5711 21.4079 11.9267 21.4079H26.6742C27.0298 21.4079 27.3708 21.263 27.6223 21.0051C27.8736 20.7472 28.0149 20.3975 28.0149 20.0328V11.7824Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.1109 18.425C20.7769 18.425 22.1274 17.0399 22.1274 15.3312C22.1274 13.6225 20.7769 12.2373 19.1109 12.2373C17.4449 12.2373 16.0944 13.6225 16.0944 15.3312C16.0944 17.0399 17.4449 18.425 19.1109 18.425Z" stroke="white" stroke-width="1.1296" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="action-screenshotactionicon-clip0">
    <rect width="37" height="30" rx="7" fill="white"/>
    </clipPath>
    </defs>
  </svg>
</template>
